import styled from 'styled-components';

export const DashContainer = styled.div.attrs(({ isMobile }) => ({
  className: isMobile ? 'col-12 px-0' : 'col-10 px-0'
}))`
  background-color: ${({ theme }) => theme.white};
  height: 100vh;
  overflow-y: hidden;
`

export const ScrollContainer = styled.div`
  height: calc(100vh - 64px);
  overflow-y: auto;
`

export const MenuOverlay = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 9995;
  background: ${({ theme }) => theme.getRGBA(theme.blackAbs, 0.6)};
`

export const toastProgressStyles = (theme) => ({
  background: theme.mocaPurple
})